/*
 * @Descripttion: 说明
 * @Author: 聂章帅
 * @Date: 2023-11-28 17:35:23
 * @LastEditors: 聂章帅
 * @LastEditTime: 2024-05-14 14:30:11
 */

import JsRsaSign from "jsrsasign";

// 密钥对生成 http://web.chacuo.net/netrsakeypair

// 公开管理请求接口
const privateKey =
  "-----BEGIN PRIVATE KEY-----MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBAIT / wQtcsk1EzRQu9TRV8YCTmjV7B6eyXNKo10mAVQCWg28qeQOP5ifpHC4rWLctaQ + 0SzNWpLfAQE4DU8FmDj67VnkDOSAl3WIIT04DaFMu15DKMC0YcYVgwOnoDRTw9u5NSXistxR7FhxjGtu9keVtqLQReUxupKApi2IVEIjdAgMBAAECgYALShZd24l7C5sI2o + P2Le + PUk6vu3Aa2B7tT9JCu6sNRqFBirthXp46s2skZtfOSiQ37H + cp1ax6Ptu1SRtxMAWd3hUl99IH2LvZ82etl14XtyBHPPD8J5JbAwUjkJAzc0CEn7IuMzjhz0NZIlyyIryh55X6nlnSz3SbEQefE1YQJBAO1SQxr7X5tjxgn0xQZAneBOCVRgVF5gr6v9DC6NCl5O1z7ZObgAW420PtU / ri2Oib5uLK / Lzo5aA6nfiwZgdmkCQQCPd4YbAhbfTUh2aum3cKjibNYzyJkacxaVpCi3Ls7gJDxyV / mFMh + In + 3pma1XsDTgr6s5NxLhUrw4mkyiSHhVAkEAweR7vwexTRtvKaM5dapFUoVvSeiKBbGo1TOhSEcjOXngkhCX / 6ULJ / MjgsbMX5wdHeCV0esJj3QrmhZxV3xoQQJAafD + M7WARFdieieK / O4RmFp8dvLbtD9mXwxBELxdAgFgLaOvW19fD9nhqs3TxlwVQBIY44A6ze71lOrESlYvnQJBAOjaELZkBnVXhFTFBTWchdIcChPfcw5uJwP6fSJVW0re5qEoRl7yktxv5sxvmK2hF / n8g6Hc2P17fyZWvjT2UkQ=-----END PRIVATE KEY-----";

/**
 * SHA256和RSA加签
 * @param privateKey 私钥
 * @param msg 加签内容
 * @returns {string} Base64编码签名内容
 */
export function signBySHA256WithRSA(idCard, timeStamp) {
  const key = JsRsaSign.KEYUTIL.getKey(privateKey);
  const signature = new JsRsaSign.KJUR.crypto.Signature({
    alg: "MD5withRSA",
  });
  signature.init(key);

  let str = "deptId=" + "" + "&idCard=" + idCard + "&timeStamp=" + timeStamp;
  // console.log(str);
  signature.updateString(str);
  // console.log(JsRsaSign.hextob64(signature.sign()));
  // 签名后的为16进制字符串，这里转换为16进制字符串
  return JsRsaSign.hextob64(signature.sign());
}

export function signBySHA256WithRSAWB(deptId, timeStamp) {
  const key = JsRsaSign.KEYUTIL.getKey(privateKey);
  const signature = new JsRsaSign.KJUR.crypto.Signature({
    alg: "MD5withRSA",
  });
  signature.init(key);

  let str = "deptId=" + deptId+  "&timeStamp=" + timeStamp;
  // console.log(str);
  signature.updateString(str);
  // console.log(JsRsaSign.hextob64(signature.sign()));
  // 签名后的为16进制字符串，这里转换为16进制字符串
  return JsRsaSign.hextob64(signature.sign());
}
